import BaseTable from 'components/Tables/BaseTable';
import { actions as scenariosDescriptorsActions } from 'ducks/scenariosDescriptors';
import { sortBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData } from 'selectors/generic';
import theme from 'source/theme';
import arrayToObject from 'utils/arrayToObject';
import columns from 'utils/tables/columns/scenarioExposure/scenarioDescriptorsExposure';
import { currentUser } from 'selectors/currentUser';

const Component = props => {
  const {
    descriptorId, descriptorsById, descriptorsData, descriptorFilter, lcs,
    scenarioDescriptorsData, substanceId, scenario, TABLE_HEIGHT, user
  } = props;
  const {
    createScenarioDescriptor, removeScenarioDescriptor, setDescriptorId,
    updateScenarioDescriptor
  } = props;
  const tableRef = React.useRef(null);

  const filteredDescriptors = descriptorsData.filter(v => v.descriptor_type_id === descriptorFilter);

  const filteredScenarioDescriptors = scenarioDescriptorsData.filter(sd =>
    sd.scenario_id === scenario.id &&
    descriptorsById[sd.descriptor_id].descriptor_type_id === descriptorFilter
  );

  const fSDByDescriptorId = arrayToObject(filteredScenarioDescriptors, 'descriptor_id');

  const [selectedIds, setSelectedIds] = useState(filteredScenarioDescriptors.map(fsd => fsd.descriptor_id));
  const [loading, setLoading] = useState(false);

  useEffect(
    () => setSelectedIds(filteredScenarioDescriptors.map(fsd => fsd.descriptor_id)),
    // TODO Falta adicionar no useEffect rerun o shipment_id
    [loading, lcs, scenario, substanceId, scenarioDescriptorsData]
  );

  // TODO Adding Checked info to table, there should be a better way
  const rows = filteredDescriptors.map(descriptor => {
      const ok_flag = fSDByDescriptorId[descriptor.id] && fSDByDescriptorId[descriptor.id].ok_flag;
      const notes = fSDByDescriptorId[descriptor.id] && fSDByDescriptorId[descriptor.id].notes;
      return selectedIds.includes(descriptor.id) ?
        {
          ...descriptor,
          ok_flag: ok_flag ? ok_flag : false,
          notes: notes ? notes : '',
          tableData: { checked: true }
        } :
        { ...descriptor, tableData: { checked: false } };
    }
  );
  const reOrderedRows = sortBy(rows, [o => !selectedIds.includes(o.id), 'id']);

  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        title={'ESCOLHA OS DESCRITORES'}
        columns={columns(user)}
        data={scenario ? reOrderedRows : []}
        order={false}
        onRowClick={() => null}
        onRowDoubleClick={setDescriptorId ? rowData => setDescriptorId(rowData.id) : null}
        paging={false}
        options={{
          // toolbar: false,
          // search: false,
          maxBodyHeight: TABLE_HEIGHT,
          minBodyHeight: TABLE_HEIGHT,
          selection: true,
          showTextRowsSelected: false,
          showSelectAllCheckbox: false,
          rowStyle: setDescriptorId ?
            rowData => rowData.id === descriptorId ?
              { backgroundColor: theme.palette.primary.light } :
              null :
            null
        }}
        isLoading={loading}
        onSelectionChange={(rows, difRow) => {
          setLoading(true);
          if (rows.length > selectedIds.length) {
            createScenarioDescriptor({ descriptor_id: difRow.id, scenario_id: scenario.id })
              .finally(() => setLoading(false));
          } else {
            const id_sd = filteredScenarioDescriptors.find(fsd => fsd.descriptor_id === difRow.id).id;
            removeScenarioDescriptor(id_sd)
              .finally(() => setLoading(false));
          }
        }}
        editable={{
          // isEditable: rowData => selectedIds.includes(rowData.id),
          onRowUpdate: (newData) => {
            setLoading(true);
            if (selectedIds.includes(newData.id)) {
              // update
              const id_sd = filteredScenarioDescriptors.find(fsd => fsd.descriptor_id === newData.id).id;
              return updateScenarioDescriptor(id_sd, newData)
                .finally(() => setLoading(false));
            } else {
              // create
              return createScenarioDescriptor({
                descriptor_id: newData.id,
                scenario_id: scenario.id,
                notes: newData.notes,
                ok_flag: newData.ok_flag
              })
                .finally(() => setLoading(false));
            }
          }
        }}
      />
    </React.Fragment>
  );
};


const makeMapStateToProps = () => {
  const immutableDescriptorsData = getImmutableStoreData('descriptors');
  const mapStateToProps = (state, props) => ({
    descriptorsData: immutableDescriptorsData(state),
    descriptorsById: state.descriptors.models,
    scenarioDescriptorsData: state.scenarioDescriptors.data,
    user: currentUser(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  createScenarioDescriptor: data => dispatch(scenariosDescriptorsActions.createPromise(data)),
  removeScenarioDescriptor: id => dispatch(scenariosDescriptorsActions.removePromise(id)),
  updateScenarioDescriptor: (id, data) => dispatch(scenariosDescriptorsActions.updatePromise(id, data))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
